import { format, isValid } from "date-fns";
import { isIP } from 'is-ip';
import isCidr from "is-cidr";

export const generateLogoUrl = (customerId) => {
  return `https://tcncmpcardart.s3.ap-southeast-2.amazonaws.com/tcncplogos/${customerId}.png`;
};

export const formatDate = (date, dateFormat) => {
  if (isValid(new Date(date))) {
    return date ? format(new Date(date), dateFormat) : null;
  } else {
    return 'Invalid date';
  }
};

export const isValidCIDR = (input) => isCidr(input);

export const isValidIPAddress = (input) => isIP(input) > 0;
